import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class NotificationsService extends ApiService {
    baseUrl = 'notification';
    removeAllUrl = 'notification/clear'; // Удалить все
    readUrl = 'notification/read';  // Сделать прочитанными переданные уведомления
    readAllUrl = 'notification/read-all';  // Сделать все прочитанными

    public handleHttpFailErrors(error: HttpErrorResponse) {
        this.logger.log(error);
    }
}
